import { css } from '@emotion/react';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';

export const pricingContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0.25rem;
  align-items: flex-end;
  position: relative;
  top: 72px;

  ${getMediaDown('md')} {
    top: 0;
    align-items: flex-start;
    position: relative;
    padding: 1rem 0 0 1.125rem;
    margin-left: 0.625rem;
    padding-top: 0rem;
  }
`;

export const monthlyPriceStyle = css`
  color: ${getColor('n800')};
  text-align: right;
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 1rem;
  letter-spacing: 0.019rem;
  margin: 0 0 0.375rem;
  ${getMediaDown('md')} {
    text-align: left;
  }
`;

export const userPriceStyle = css`
  color: ${getColor('n400')};
  text-align: right;
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0 0 0.125rem;
  ${getMediaDown('md')} {
    text-align: left;
  }
`;

export const removeButtonStyle = css`
  color: ${getColor('b300')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 1rem;
  cursor: pointer;
  background: none;
  border: none;
  padding-inline: 0;
  padding-block: 0;
  &:hover,
  &:focus {
    color: ${getColor('b500')};
  }
`;
